import React from 'react';
import PropTypes from 'prop-types';

import './HeroImage.less';

const CNAME = 'HeroImage';

class HeroImage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      imageSrc: this.props.placeholderSrc
    };
  }

  componentDidMount() {
    this.lazyLoadImg();
  }

  lazyLoadImg() {
    const img = document.createElement('img');
    const { imageSrc } = this.props;

    img.addEventListener('load', () => this.setState({ imageSrc }));
    img.src = imageSrc;
  }

  render() {
    const { children } = this.props;
    const { imageSrc } = this.state;

    const style = imageSrc && { 'backgroundImage': `url("${imageSrc}")` };

    return (
      <div className={CNAME} style={style}>
        <div className={`${CNAME}__content`}>
          {children}
        </div>
      </div>
    );
  }
}

HeroImage.propTypes = {
  placeholderSrc: PropTypes.string.isRequired,
  imageSrc: PropTypes.string.isRequired
};

export default HeroImage;



// WEBPACK FOOTER //
// ./src/universal/components/HeroImage/HeroImage.js